<template lang="html">
    <div v-if="searchComplete && resultsReturned > 0">
        <div class="row">
            <div class="col-4 pt-2 pl-0 mb-2">              
              <span class="add-remove-items">  
                <i v-if="listInPersonalList" class="fas fa-star" @click="removeListFromSaved"></i>
                <i v-else class="far fa-star" @click="addListToSaved"></i>
              </span>
              <span v-if="more">+</span>{{resultsReturned}} {{hebrew ? 'תוצאות' : 'Results'}} <span v-if="currentList === 'Tavnit'">(כולל לקסמות)</span>
            </div>           
        </div>
    </div>
</template>

<script lang="js">
  import _ from "lodash"
  import {RunStates} from '@/store/runStates'
  export default  {
    name: 'ResultsHeading',
    props: ['resultsNum', 'more', 'listDisplayed'],
    mounted() {
    },
    data() {
      return {
        
      }
    },
    methods: {
      addListToSaved () {
        let newPersonalList = _.union(this.personalList, this.listDisplayed)
        this.$store.commit('REPLACE_LIST',  newPersonalList)
      },
      removeListFromSaved () {
        let newPersonalList  = this.personalList.filter(x => !this.listDisplayed.includes(x))
        this.$store.commit('REPLACE_LIST',  newPersonalList)
      }
    },
    watch: {
    },
    computed: {
      resultsReturned () {
        return this.resultsNum
      },
      additionalResults () {
        return this.more
      },      
      hebrew () {
        return this.$settings.hebrew
      },
      searchComplete () {
        return this.$store.state.charuzitApiState === RunStates.COMPLETE
      },
      listInPersonalList () {
        return this.listDisplayed.every(v => this.personalList.includes(v))
      },
      personalList () {
        return this.$store.state.personalWords
      },
      currentList () {
        return this.$store.state.viewMode
      }
    }

}
</script>
<style scoped lang="scss">
  .add-remove-items {
    margin: 0 10px 0 5px;
    i {
      cursor: pointer;
      font-size: 13px;
      &.fas {
        color: #FFE452;
      }
    }
  }
</style>